import { render, staticRenderFns } from "./three-resource-buckets.component.vue?vue&type=template&id=ce960506&"
import script from "./three-resource-buckets.component.vue?vue&type=script&lang=ts&"
export * from "./three-resource-buckets.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports